@import '../../assets/styles/components.css';

@layer components {
  :host {
    @apply cursor-pointer gap-x-2 inline-flex items-start relative text-neutral-dark;

    .radio-container {
      @apply leading-none relative;
      @apply duration-150 ease-out transition;
      @apply appearance-none cursor-pointer;
      @apply bg-neutral-lightest text-brand;
      @apply border border-secondary-200 border-solid rounded-full;
      @apply h-6 w-6 min-w-[1.5rem];
      @apply focus:outline-none focus:ring focus:ring-primary-200;
      @apply hover:bg-neutral-lightest hover:border-brand-600;
      @apply active:bg-brand-50 active:border-brand-700;
      @apply before:transform-gpu before:-translate-x-1/2 before:-translate-y-1/2;

      &:invalid {
        @apply border-danger;
      }
    }

    abds-label {
      @apply mt-0.5;
    }

    &([checked]) .radio-container {
      @apply before:content-[''];
      @apply before:duration-150 before:ease-out before:transition;
      @apply before:h-3 before:w-3 before:rounded-full;
      @apply before:bg-brand;
      @apply before:absolute before:top-1/2 before:left-1/2;
      @apply hover:before:bg-brand-600;
      @apply active:before:bg-brand-700;
    }

    /** default order is text/icon on right and input on left */
    &([alignment=end]) .radio-container {
      @apply order-2;
    }

    &([disabled]) {
      @apply pointer-events-none;

      abds-label {
        @apply cursor-default;
      }

      .radio-container {
        @apply before:bg-secondary-400;
        @apply bg-secondary-50 border-secondary-100;
      }
    }
  }
}
